module.exports = __webpack_public_path__ + "img/close-black.b1441846.svg";